export default __webpack_public_path__ + "static/media/O2-bubble-3D-animations-04@05x 1.f5ae65dc.png";